module.exports = __webpack_public_path__ + "js/5-62476b1c345865b38393.chunk.worker.js"